import * as React from "react"
import { Link, graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MarkdownData, NextData, PreviousData, SiteData } from "@interfaces/gatsby"
import MainLayout from "@layouts/Main"

import { MarkdownProvider } from "@components/Markdown"

export interface DataProps {
  setId: (value: string) => void
  data: {
    site: SiteData
    mdx: MarkdownData
    previous: PreviousData
    next: NextData
  }
  location: Location
}

const MarkdownTemplate: React.FC<DataProps> = ({ data, location }) => {
  const page = data.mdx
  const { previous, next } = data

  return (
    <MainLayout location={location}>
      <article itemScope itemType="http://schema.org/Article">
        <header>
          <h1 itemProp="headline">{page.frontmatter.title}</h1>
        </header>
        <MarkdownProvider>
          <MDXRenderer>{page.body}</MDXRenderer>
        </MarkdownProvider>
        <hr />
      </article>
      <nav>
        <div>
          {previous && (
            <Link to={previous.fields.slug} rel="prev">
              ← {previous.frontmatter.title}
            </Link>
          )}
        </div>
        <div>
          {next && (
            <Link to={next.fields.slug} rel="next">
              {next.frontmatter.title} →
            </Link>
          )}
        </div>
      </nav>
    </MainLayout>
  )
}

export default MarkdownTemplate

export const pageQuery = graphql`
  query MarkdownPageBySlug($slug: String!, $previousPageId: String, $nextPageId: String) {
    site {
      siteMetadata {
        title
        author
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
      body
    }
    previous: mdx(id: { eq: $previousPageId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: mdx(id: { eq: $nextPageId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
